import React, { useContext, useState } from 'react';

import { Button, FilterIcon, Modal, Text } from '@freenow/wave';
import { config } from '@mytaxi/config-store';

import { BusinessAccount } from '../api/central-organisations.api';
import { BusinessAccountContext } from '../context/BusinessAccountContext';
import { useFormatMessage } from '../hooks/useFormatMessage';
import { BusinessAccountSelectorList } from './BusinessAccountSelectorList';

export const BusinessAccountSelector = ({
    marginBottom = 0,
    buttonSize = 'small',
    filter,
}: {
    marginBottom?: number;
    buttonSize?: string;
    filter?: (businessAccount: BusinessAccount) => boolean;
}) => {
    const formatMessage = useFormatMessage();
    const { currentBusinessAccount, setSearch, setPage, totalBusinessAccounts, setIsSelectingBusinessAccount } =
        useContext(BusinessAccountContext);
    const [showBusinessAccountSelectorModal, setShowBusinessAccountSelectorModal] = useState(false);

    const onClose = () => {
        setShowBusinessAccountSelectorModal(false);
        setPage(0);
        setSearch('');
        setIsSelectingBusinessAccount(false);
    };

    if (totalBusinessAccounts === 1 || !config.getItem('featureFlags.newBaStructureEnabled')) {
        return null;
    }

    const baName = currentBusinessAccount?.name;
    const inAppName = currentBusinessAccount?.settings?.useInAppName
        ? currentBusinessAccount?.settings?.inAppName
        : undefined;

    const displayName = inAppName && baName && inAppName !== baName ? `${baName}  / ${inAppName}` : baName;

    return (
        <>
            <Button
                size={buttonSize}
                variant="secondary"
                onClick={() => {
                    setShowBusinessAccountSelectorModal(true);
                    setIsSelectingBusinessAccount(true);
                }}
                mb={marginBottom}
            >
                <FilterIcon size={16} />
                <Text fontSize={1} ml={1}>
                    {`${formatMessage('businessAccountSelector.buttonPrefix')}: ${displayName || ''}`}
                </Text>
            </Button>

            {showBusinessAccountSelectorModal ? (
                <Modal onClose={onClose}>
                    {(dismiss) => <BusinessAccountSelectorList onSelect={dismiss} filter={filter} />}
                </Modal>
            ) : null}
        </>
    );
};
